/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: patched for B4A-7073 (IsKit / ProductKit).
 */

import { ProductKitComponent } from './productKitComponent';

export interface ProductVariantUpdateRequest {
  allocationCost?: number;
  brinde?: boolean;
  cean?: string;
  cfop?: string;
  costPrice?: number;
  cst?: string;
  defaultImageURL?: string;
  diamanteVermelho?: ProductVariantUpdateRequest.DiamanteVermelhoEnum;
  displayOrder?: number;
  expirationAttribute?: string;
  externalId?: number;
  externalStoreUrl?: string;
  extipi?: string;
  genero?: string;
  internalEAN?: string;
  invoiceName?: string;
  invoicePrice?: number;
  isSellableUrl?: boolean;
  isTradeable?: boolean;
  isKit?: boolean;
  kitComponents?: Array<ProductKitComponent>;
  longExternalStoreUrl?: string;
  maxTradesPerPerson?: number;
  ncm?: string;
  productId?: number;
  productVariantId?: number;
  productVariantName?: string;
  qtdItens?: number;
  salePrice?: number;
  tipoEstoque?: ProductVariantUpdateRequest.TipoEstoqueEnum;
  tradeActive?: boolean;
  tradePoints?: number;
  unitMeasure?: number;
  unitName?: string;
  weight?: number;
  wmsId?: number;
}
export namespace ProductVariantUpdateRequest {
  export type DiamanteVermelhoEnum =
    | 'red diamond'
    | 'red diamond bag'
    | 'red diamond box'
    | 'red diamond combo';
  export const DiamanteVermelhoEnum = {
    Diamond: 'red diamond' as DiamanteVermelhoEnum,
    DiamondBag: 'red diamond bag' as DiamanteVermelhoEnum,
    DiamondBox: 'red diamond box' as DiamanteVermelhoEnum,
    DiamondCombo: 'red diamond combo' as DiamanteVermelhoEnum
  };
  export type TipoEstoqueEnum = 'classico' | 'premium';
  export const TipoEstoqueEnum = {
    Classico: 'classico' as TipoEstoqueEnum,
    Premium: 'premium' as TipoEstoqueEnum
  };
}
